const shared = require('./shared');

module.exports = {
  get authHeadersForAPI() {
    return shared.getAuthHeadersForAPI();
  },
  get cookiesForDownstreamAPIs() {
    return shared.getCookiesForDownstreamAPIs();
  },
  get B2BHeadersForAPI() {
    return shared.getB2BHeaders();
  },
  getCustomerInfo() {
    return shared.getCustomerInfo();
  },
  getHeadersForAPI() {
    const headers = shared.getCommonHeadersForAPI({ isServer: false });
    if (window.location.pathname.startsWith('/bassPV/')) {
      headers['x-content-preview'] = true;
    }
    return headers;
  }
};
